/**
 * O componente EmptyElement é usado para preencher espaços vazios sem quebrar as propriedades fullWidth (flex).
 *
 * @componente
 * @exemplo
 * return (
 *   <EmptyElement />
 * )
 */
import { InputBase } from "@material-ui/core";


const EmptyElement = () => (
  <InputBase
    id={Math.random().toString()}
    inputProps={{ 'aria-label': 'naked' }}
    fullWidth
    disabled
  />
);

export default EmptyElement;